._text_y2n1q_1 {
  padding: 12px 30px;
  text-align: center; }
  ._text_y2n1q_1 * {
    vertical-align: bottom; }
